<template>


  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <e-fatura-ekli-dosya ref="efaturaeklidosya"></e-fatura-ekli-dosya>
    <TekrarGonderDosyaEkle ref="efatTekrarEkliDosya"></TekrarGonderDosyaEkle>
    <v-app  light >
      <v-card flat >
        <v-layout row wrap >
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"> {{ $t('Invoice-Details-v2') }} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                  class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Free-Invoice')}) }} </span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Free-Invoice')}) }}</span>
            </v-tooltip>



          </v-toolbar>

          <v-tabs style="width:100%; height:100%" dark v-model="active" color="blue darken-4
" slot="extension" slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              {{$t("tab_general")}}
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-container fluid  ma-0 pa-0 fill-height>
                <v-layout row wrap>
                  <v-flex overflow-x-hidden xs12 sm12 md7 style="padding-right:10px;">
                    <v-card class="white--text">
                      <v-container>
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout align-center justify-center row wrap fill-height>
                              <v-flex xs12 sm12 md12>
                                <v-layout align-center justify-center row wrap fill-height>
                                  <v-progress-circular v-if="!sonucgeldi" :size="35" :width="3" color="pink"
                                    indeterminate></v-progress-circular>
                                </v-layout>
                              </v-flex>
                              <v-flex v-if="!sonucgeldi" xs12 sm12 md12>
                                <v-layout align-center justify-center row wrap fill-height>

                                  <span>  {{ $t('Invoice-Preview-is-being-Created') }} </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 pt-1 pr-5 md12>
                                <v-layout align-center justify-end row wrap fill-height>
                                  <v-btn outline v-if="sonucgeldi" @click="denemeyazdir('demo2')" color="info">
                                    <v-icon>print</v-icon>
                                  </v-btn>

                                </v-layout>
                              </v-flex>



                              <!-- <span style="align:center;" id="demo2"></span> -->

                              <iframe scrolling="yes" v-show="sonucgeldi && faturatur=='0'" id="demo3" src=""
                                height="800" width="700px" type="application/pdf">  
                              </iframe>
                              
                              <div class="ScrollStyle" scrolling="yes" v-show="faturatur!='0' && sonucgeldi" id="demo2"
                                height="700px;" width="100%"></div>

                              <!-- <iframe scrolling="yes" v-show="faturatur!='0' && sonucgeldi" id="demo2" src=""
                                height="700px;" width="100%">

                              </iframe> -->
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md5>
                    <v-card class="white--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row wrap>

                            <v-flex ma-2 xs12 sm12 md12>
                              <v-flex xs12 sm12 md12 style="padding-right:2px;">
                                <v-card color="#1E88E5" class="white--text">
                                  <v-layout>
                                    <v-flex xs2 sm2 md2>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="white" large="">info</v-icon>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm10 md10>

                                      <v-card-title primary-title="">

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  {{$t('Currentcode_label')}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  : {{carikod}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  {{$t('Title_label')}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  : {{unvan}}
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm3 md3>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  <div class="font-weight-bold caption  white--text  mb-1">{{ $t('Credit-Limit') }}
                                                  </div>
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs12 sm9 md9>
                                              <v-list-tile-title>
                                                <span class="caption font-weight-bold">
                                                  <div class="font-weight-bold caption  white--text  mb-1">:
                                                    {{kredilimit | moneyformat }} {{this.getparabirimi()}} </div>
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>

                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                  <v-card-actions class="pa-3">
                                    {{ $t('Invoice-Summarized-Details') }} 
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-flex>
                            </v-flex>

                            <v-flex ma-2 xs12 sm12 md12>
                              <v-flex xs12 sm12 md12 style="padding-right:2px;">
                                <v-card color="#FF5252" class="white--text">
                                  <v-layout>


                                    <v-flex xs2 sm2 md2>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="white" large="">email</v-icon>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm10 md10>

                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs12 sm10 md10>
                                              <v-text-field v-model="email" solo class="white--text" name="email"
                                                :label="$t('Email_label')" type="text" :rules="[rules.required, rules.email]">
                                              </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm2 md2>
                                              <v-layout justify-center="" fill-height="">

                                                <v-btn @click="mailgonder()" flat icon color="white">
                                                  <v-icon large>near_me</v-icon>
                                                </v-btn>
                                              </v-layout>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>

                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                  <v-card-actions class="pa-3">
                                    {{ $t('Send-Invoice-Mail-Address') }}
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-flex>
                            </v-flex>

                            <v-flex ma-2 v-show="efaturali" xs12 sm12 md12 v-if="!sovos">
                              <v-layout row wrap justify-end="">
                                <v-flex pa-1 xs12 sm6 md6>

                                  <v-tooltip bottom>
                                    <v-btn block outline color="info" :disabled="!sayfayetki.Update" slot="activator"
                                      @click="onayaGonder()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{ $t('Send-Invoice-for-Approval') }} </span>
                                      </span>
                                      <v-icon right dark>playlist_add_check</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">  {{ $t('Send-Invoice-for-Approval') }} </span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md6>

                                  <v-tooltip bottom>
                                    <v-btn block outline color="info" :disabled="!sayfayetki.Update" slot="activator"
                                      @click="tekrarOnayaGonderSor()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{ $t('Send-Invoice-for-Re-Approval') }} </span>
                                      </span>
                                      <v-icon right dark>playlist_add_check</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Send-Invoice-for-Re-Approval') }}</span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                      @click="KesinBasariliIsaretle()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down"> Kesin Başarılı İşaretle</span>
                                      </span>
                                      <v-icon right dark>assignment_turned_in</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> Kesin Başarılı İşaretle</span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                      @click="FaturaIptal()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{$t('Cancel-Invoice')}} </span>
                                      </span>
                                      <v-icon right dark>cancel</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Cancel-Invoice') }}</span>
                                  </v-tooltip>
                                </v-flex>
                                <!-- <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                      @click="FaturaSil()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down"> FaturaSil</span>
                                      </span>
                                      <v-icon right dark>delete</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> FaturaSil</span>
                                  </v-tooltip>
                                </v-flex> -->
                                <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                      @click="DialogShowManuelNoVer(1)"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{ $t('Enter-Manual-No') }} </span>
                                      </span>
                                      <v-icon right dark>filter_1</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">  {{ $t('Enter-Manual-No') }} </span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                      @click="DialogShowManuelNoVer(2)"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{ $t('Enter-Approval-Invoice') }} </span>
                                      </span>
                                      <v-icon right dark>filter_1</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Enter-Approval-Invoice') }}</span>
                                  </v-tooltip>
                                </v-flex>

                                 <v-flex pa-1 xs12 sm6 md6>
                                  <v-tooltip bottom>
                                    <v-btn color="info" outline block :disabled="!sayfayetki.Update" slot="activator"
                                    
                                      @click="EFaturaGonderDosyaEkle()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  {{ $t('Add-Send-File') }} </span>
                                      </span>
                                      <v-icon right dark>attach_file</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Add-Send-File') }}</span>
                                  </v-tooltip>
                                </v-flex> 

                                 <v-flex pa-1 xs12 sm6 md6>
                                     <v-tooltip bottom>
                                    <v-btn block outline color="info" :disabled="!sayfayetki.Update" slot="activator"
                                      @click="tekrarOnayaDosyaGonderSor()"> <span class="hidden-sm-and-down"> <span
                                          class="hidden-sm-and-down">  Tekrar Onaya Dosya Gönder </span>
                                      </span>
                                      <v-icon right dark>playlist_add_check</v-icon>
                                    </v-btn>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> Tekrar Onaya Dosya Gönder </span>
                                  </v-tooltip>
                                </v-flex> 

                              </v-layout>
                            </v-flex>


                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab href='#1'>
              {{ $t('Invoice-Information') }}
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout row="" wrap v-if="biletvarmi">

                <v-flex xs12 sm12 md12>
                  <v-card>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md9>
                          <v-layout align-center="" fill-height="">
                            <div class=" font-weight-large grey--text title ">
                              &nbsp; {{recordcount}} <span v-if="filtreticket.length>0"
                                class=" font-weight-large red--text title ">
                                {{filtreticket.length}}  {{$t('number-records-listed')}}. </span>
                            </div>
                          </v-layout>
                        </v-flex>

                      </v-layout>

                    </v-flex>



                    <v-list two-line>
                      <template v-for="item in filtreticket">
                        <v-layout row wrap v-bind:key="item.GenelBilgileri.BiletNo">
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout justify-center="" align-center>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                          <v-flex sm12 md1>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="60%" width="60%"
                                    contain></v-img>
                                  <v-img v-if="item.GenelBilgileri.Acente =='A'"
                                    :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" alt="K" height="21px"
                                    width="86px" contain></v-img>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout align-start justify-start row fill-height>
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row align-center justify-start>
                                      <v-chip v-if="item.GenelBilgileri.Status=='S' " small="" color="green"
                                        text-color="white">{{$t('Sales')}}</v-chip>
                                      <v-chip v-if="item.GenelBilgileri.Status=='Ia' " small="" color="red"
                                        text-color="white">{{$t('Refund')}}</v-chip>
                                      <v-chip v-if="item.GenelBilgileri.Status=='V' " small="" color="yellow"
                                        text-color="white">{{$t('Void')}}</v-chip>
                                      <v-list-tile-title> <span class='grey-text--primary caption '>
                                          {{item.GenelBilgileri.HavaYoluKodu}} -
                                          {{item.GenelBilgileri.BiletNo}} -
                                          {{item.GenelBilgileri.UcusTipi}} </span>
                                      </v-list-tile-title>
                                    </v-layout>
                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                        {{item.GenelBilgileri.YolcuAdi}}</span>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                        {{item.GenelBilgileri.MusteriKodu.Kod}}
                                        -{{item.GenelBilgileri.MusteriKodu.Unvan}} </span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout align-start justify-start row fill-height>
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row wrap align-center="" justify-start>
                                      <v-list-tile-title>
                                        <div class="font-weight-large red--text title">
                                          {{item.TarihBilgileri.SatisTarihi}}</div>
                                      </v-list-tile-title>
                                      <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='Ia'">
                                        <div class="font-weight-large grey--text caption">
                                          {{$t('Refund-Date')}}: <span class="font-weight-large red--text caption">

                                            {{item.TarihBilgileri.IadeTarihi}} </span>
                                        </div>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='V'">
                                        <div class="font-weight-large grey--text caption ">
                                          {{$t('Void-Date')}} :<span class="font-weight-large red--text caption">
                                            {{item.TarihBilgileri.IptalTarihi}} </span>
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-layout>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout align-start="" justify-start fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content style="'overflow=inherit';">
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption "> {{$t('Invoice-Date')}}:
                                            {{item.FaturaBilgileri.FaturaTarihi}} </div>
                                        </v-list-tile-sub-title>

                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption "> {{$t('Invoice-No')}}:
                                            {{item.FaturaBilgileri.FaturaNo}}
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Beklemede'"
                                            class="font-weight caption ">
                                            <v-icon hide-details color="yellow" small="">access_alarm</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>

                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Alıcı Onayladı'"
                                            class="font-weight caption ">
                                            <v-icon hide-details color="green" small="">check_box</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>



                                          <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Gönderildi'"
                                            class="font-weight caption ">
                                            <v-icon hide-details color="red" small="">send</v-icon>
                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                          </div>

                                        </v-list-tile-sub-title>


                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>

                            </v-layout>
                          </v-flex>


                          <v-flex xs12 sm4 md2>
                            <v-layout>

                              <v-flex xs12 sm6 md6>
                                <v-layout align-start="" justify-start fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content style="'overflow=inherit';">
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            {{$t('Ticket-Amount')}}:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            {{$t('Taxes')}}:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">
                                            {{$t('Service-Cost')}}:
                                          </div>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <div class="font-weight caption ">

                                          </div>
                                        </v-list-tile-sub-title>

                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm6 md6>
                                <v-layout row justify-end="" fill-height>
                                  <v-card flat="">
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end>
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.Tutar.Tutar}}  &nbsp;  </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end="">
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.Vergiler}} &nbsp;  
                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="" justify-end="">
                                            <div class="font-weight caption ">
                                              {{item.TutarBilgileri.ServisBedeli}} &nbsp;
                                              
                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title>
                                          <v-layout align-center="">
                                            <div class="font-weight caption ">

                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </v-card>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <!-- <v-flex class="hidden-md-and-up" xs1 sm1 md1>
                                </v-flex> -->

                          <v-flex xs12 sm4 md1>
                            <v-layout row align-center justify-center="" fill-height="">
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-layout row wrap justify-center="">
                                      <v-list-tile-title>
                                        <v-layout row wrap justify-center="">
                                          {{$t('Net-Amount')}}
                                        </v-layout>
                                      </v-list-tile-title>
                                      <v-list-tile-sub-title>
                                        <v-layout row wrap justify-end="">
                                          <div class="red--text subheading">
                                            {{item.TutarBilgileri.NetTutar.NetTutar }} &nbsp;    </div>
                                        </v-layout>

                                      </v-list-tile-sub-title>
                                      <v-list-tile-title>
                                        <v-layout row wrap justify-center="">
                                          <div class="font-weight green--text caption ">
                                            {{item.OdemeBilgileri.SatisSekli}}
                                          </div>
                                        </v-layout>

                                      </v-list-tile-title>
                                    </v-layout>
                                  </v-list-tile-content>

                                </v-list-tile>
                              </v-card>
                            </v-layout>
                          </v-flex>

                          <v-flex sm4 md1>

                            <v-layout row align-center justify-end="">
                              <v-card flat="">
                                <v-list-tile>

                                  <v-list-tile-action>
                                    <v-layout align-center="" fill-height="" justify-end>
                                      <v-flex sm6 md6>
                                        <a v-if="item.GenelBilgileri.Status!='V'" target="_blank"
                                          v-bind:href="'#/bilet/yeni/id?' + 'isl=get&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                          <v-btn icon>
                                            <v-icon x-large="" color="grey">search</v-icon>
                                          </v-btn>
                                        </a>

                                        <a v-if="item.GenelBilgileri.Status=='V'" target="_blank"
                                          v-bind:href="'#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                          <v-btn icon>
                                            <v-icon x-large="" color="grey">search</v-icon>
                                          </v-btn>
                                        </a>
                                      </v-flex>

                                    </v-layout>

                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-card>
                            </v-layout>

                          </v-flex>

                        </v-layout>
                        <v-divider :key="item.id" inset></v-divider>
                      </template>
                    </v-list>

                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#2'>
              UBL-TR
            </v-tab>


            <v-tab-item :id="'2'" style="width:100%; height:100%;">
            
                <v-btn color="blue darken-1" @click="efaturagoster()">Get XML</v-btn>

                <textarea rows="20" cols="200" style="border:none;" id="demo2XML">
  
  
                </textarea>   

            </v-tab-item>


          </v-tabs>












          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>




        </v-layout>
      </v-card>
    </v-app>




    <v-dialog v-model="faturanodialog" scrollable="" max-width="400px">
      <v-card>
        <v-card-title>{{ $t('E-Invoice') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formfaturano" v-model="valid" lazy-validation>

            <v-layout row wrap="">
              <v-flex sm12 md12 xs12>
                {{  $t('Proforma-No') }} : {{FaturaIcerik.Fatura.seriYilNo}}
              </v-flex>

              <v-flex sm12 pb-2 md12 xs12>
                {{  $t('Proforma-Date') }} : {{FaturaIcerik.Fatura.tarih | dateformat}}
              </v-flex>

              <v-flex sm12 md12 xs12>
                <tarihcomp :etiket="$t('GIB-Invoice-Date')" :detaygizle="false"
                  :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                  v-bind:value="YeniFatura.tarih" v-model="YeniFatura.tarih"></tarihcomp>

              </v-flex>

              <v-flex sm12 md12 xs12>
                <v-text-field :label="$t('GIB-Invoice-Serial')" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="YeniFatura.seri"
                  maxlength=3></v-text-field>

              </v-flex>

              <v-flex sm12 md12 xs12>
                <v-text-field :label="$t('GIB-Invoice-No')" v-model="YeniFatura.no" :rules="[v => !!v || $t('Mandatory-Areas')]"
                  type="number" min="1" mask="#########"></v-text-field>

              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="faturanodialog=false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="blue darken-1" v-if="FaturaNoTip==1" flat @click="ManuelNoVer()"> {{ $t('Enter-Manual-No') }} </v-btn>
          <v-btn color="blue darken-1" v-if="FaturaNoTip==2" flat @click="OnayFaturaNoVer()"> {{ $t('Enter-Approval-Invoice') }} </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>



    <v-dialog scrollable="" max-width="850px">
      <v-card>
        <v-card-title> {{ $t('E-Invoice') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <reportbrosablon ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura"
              objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <loadingcomp v-model="islemstatus"></loadingcomp>





  </div>


</template>


<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import axios from 'axios'
  import logoo from '../../../assets/control'
  import tool from "../coper/tools";
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import tarihcomp from '../customcomp/tarihim'
  import EFaturaEkliDosya from '../coper/comp/EFaturaEkliDosya.vue';
  import TekrarGonderDosyaEkle from '../coper/comp/TekrarGonderDosyaEkle.vue';


  export default {
    data() {
      return {
        sovos:false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        PB:"",
        valid: true,
        FaturaIcerik: {
          Fatura: {
            seri: null,
            tarih: null,
            no: 0,
          },
        },
        YeniFatura: {
          seri: null,
          tarih: null,
          no: 0,
        },
        FaturaNoTip: null,
        islemstatus: false,
        mailtype: null,
        faturatur: null,
        faturanodialog: false,
        efaturali: false,
        headers: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri',
            width: '10'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
            width: '10'
          },
          {
            text: this.$t('Invoice-Date'),
            value: 'FaturaTarih'
          },
          {
            text: this.$t('Invoice-Type'),
            value: 'Tip'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'FaturaVade'
          },
          {
            text: this.$t('Remaining'),
            value: 'Kalan'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: this.$t('VAT'),
            value: 'Kdv'
          },
          {
            text: this.$t('Current'),
            value: 'Cari.Kod'
          }
        ],
        rules: {
          required: (value) => !!value || this.$t('Mandatory-Areas'),
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('Wrong-e-mail')
          }
        },
        faturaid: null,
        faturaGuiID:null,
        file: [],
        biletvarmi: false,
        filtreticket: [],
        valid: true,
        FaturaInput: {
          SirketKodu: null,
          FaturaSeri: null,
          FaturaNo: null,
          Tip: null,
          FaturaGuid: null,
          BaslangicTarih: null,
          BitisTarih: null,
        },
        email: null,
        kredilimit: 0,
        carikod: null,
        unvan: null,
        active: null,
        sonucgeldi: false,
        dizayn: null,
        vmodelpagination: false,
        serbestAdet: 0,
        coperAdet: 0,
        biletAdet: 0,
        ToplamAdetbilcopser: 0,
        kagıtAdet: 0,
        efaturaAdet: 0,
        earsivAdet: 0,
        ToplamAdetkagefatears: 0,
        toplamKDV: 0,
        ToplamMatrah: 0,
        ToplamKDVMat: 0,
        tumunuseckaldir: false,
        siralamatipi: 'InvoiceDate',

        kayitsayisi: 0,
        kayitadet: 50,
        recordcount: null,
        kayitvarmi: true,
        searchliste: null,
        listegorunum: true,
        gorunumtipi: 'list',
        tablegorunum: false,
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],
        siralamavmodel: 0,
        siralamatipiitems: [{
          text: this.$t('Date-Ascending'),
          value: 'InvoiceDate'
        }, {
          text: this.$t('Date-Descending'),
          value: 'InvoiceDateDesc'
        }, {
          text: this.$t('Current-Ascending'),
          value: 'InvoiceCurrentCode'
        }, {
          text: this.$t('Current-Descending'),
          value: 'InvoiceCurrentCodeDesc'
        }, {
          text: this.$t('Increasing-per-Amount'),
          value: 'InvoiceAmount'
        }, {
          text: this.$t('Decreasing-per-Amount'),
          value: 'InvoiceAmountDesc'
        }, ],
        indexsayisi: 10,
        pagenumber: 1,
        sayfalama: 1,
        secilenkayitlar: [],
        tooltip: false,
        el: null,
        SerbestFatura: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          BaslangicFaturaNo: null,
          BitisFaturaNo: null,
          Cari: {
            Kod: null
          },
          MinTutar: 0,
          MaxTutar: 0,
          VadeTarihi: false,
          Bakiyeli: false,
          CariyeKaydedilmeyen: false,
          FaturaTp: 'H',
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'InvoiceDate'
          }

        },
        faturadialog: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        progress: false,


        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

        maxtutar: 'maxtutar',
        autocomplete: 'autocomplete',
        etiket: 'Max Tutar',
        dialogfatura: false,
        mintutar: 'mintutar',
        etiketmin: 'Min Tutar',

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false,
        sendFaturaNo:null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      // this.el = this.$refs.fab.$el

      try
      {
 this.creditnote=this.$route.query.creditnote;
      }
      catch{
 this.creditnote=0;
      }
     
      
      this.PB=this.getparabirimi();
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        try{
this.sovos = JSON.parse(window.localStorage.getItem('sovos'));
        }
        catch{

        }
        
        this.sonucgeldi = false;
        this.FaturaInput.SirketKodu = credentials.SirketKodu;
        this.FaturaInput.FaturaGuid = this.$route.query.guid;
        var params = this.FaturaInput;
        this.faturaid = null

        this.$http.post(auth.API_URL + 'api/Invoice/EInvoiceGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            // 'CariSirketNo': credentials.SirketKodu
          }
        }).then((response) => {

          if (response.body.FaturaBilgi != null) {


              //Mail de gonderim icin Fatura Numarasi hesaplaniyor.

              if(response.body.FaturaBilgi.OnayFaturaNo != null && response.body.FaturaBilgi.OnayFaturaNo != '' )
              {
                this.sendFaturaNo = response.body.FaturaBilgi.OnayFaturaNo;
              }else{
              var billYear = new Date(response.body.FaturaBilgi.FaturaTarihi).getFullYear();
              var billSeries;
              var billNumber = null;
              if(response.body.FaturaBilgi.FaturaSeri.length == 2){
                  billSeries = response.body.FaturaBilgi.FaturaSeri + "A";
              }else{
                  billSeries = response.body.FaturaBilgi.FaturaSeri;
              }
              
              for (let index = 9; index > response.body.FaturaBilgi.FaturaNo.length; index--) {
                
                if(billNumber != null){
                  billNumber = billNumber + "0";
                }else{
                  billNumber = "0";
                }
              }
                billNumber = billNumber + '' +response.body.FaturaBilgi.FaturaNo;

                this.sendFaturaNo = billSeries + billYear + billNumber;
              }

            this.faturaid = response.body.FaturaBilgi.EfaturaID;
            this.faturaGuiID = response.body.FaturaBilgi.GuiID;
            
            this.carikod = response.body.FaturaBilgi.FaturaMusteriKodu;
            this.unvan = response.body.FaturaBilgi.FaturaUnvani1;
            this.kredilimit = response.body.KrediLimit
            this.email = response.body.FaturaBilgi.FaturaEMail
            this.dizayn = response.body.FaturaBilgi.FaturaPdfID; //dizaynkod;


            var editdizi = [];

            if (response.body.BiletList != null) {
              this.biletvarmi = true

              this.itemsticket = response.body.BiletList;

              this.itemsticket.forEach(element => {

                var yenikayit = [];

                yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                yenikayit.GenelBilgileri = element.GenelBilgileri;

                var tarih = {
                  SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                  IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                  IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                }

                yenikayit.TarihBilgileri = tarih;

                var fatura = {
                  FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                  FaturaTarihi: tarihkontrol(element.FaturaBilgileri.EfaturaBilgileri
                    .GercekFaturaTarihi),
                  FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri.FaturaDurumu
                }

                yenikayit.FaturaBilgileri = fatura;

                var TutarBilgileri = {
                  AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                  CezaTutar: {
                    CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                  },
                  CharterTutar: element.TutarBilgileri.CharterTutar,
                  DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                  IskontoTutar: element.TutarBilgileri.IskontoTutar,
                  KaTutar: element.TutarBilgileri.KaTutar,
                  NetTutar: {
                    NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(2).replace(
                      /(\d)(?=(\d{3})+\.)/g, '$1,')
                  },
                  PtaTutar: element.TutarBilgileri.PtaTutar,
                  ReserveTutar: element.TutarBilgileri.ReserveTutar,
                  ServisTutar: {
                    ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                  },
                  TaxTutar: element.TutarBilgileri.TaxTutar,
                  Tutar: {
                    Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2).replace(
                      /(\d)(?=(\d{3})+\.)/g, '$1,')
                  },
                  YFFTutar: element.TutarBilgileri.YFFTutar,
                  Vergiler: vergihesapla(element.TutarBilgileri),
                  ServisBedeli: servishesapla(element.TutarBilgileri)
                }

                yenikayit.TutarBilgileri = TutarBilgileri
                var OdemeBilgileri = {
                  SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                }
                yenikayit.OdemeBilgileri = OdemeBilgileri;
                editdizi.push(yenikayit)
              });

              this.filtreticket = editdizi;

            } else {
              this.biletvarmi = false
            }

            this.faturatur = response.body.FaturaBilgi.EFaturaKayitli

            //E-Arşiv veya E-Fatura ise
            if (response.body.FaturaBilgi.EFaturaKayitli == '1' || response.body.FaturaBilgi.EFaturaKayitli ==
              '2') {
              this.efaturali = true
              this.mailtype = 'htm'
              var params = {
                id: response.body.FaturaBilgi.EfaturaID,
                guid: response.body.FaturaBilgi.GuiID,
                CreditNoteFilter:parseInt(this.creditnote)
              }

              this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader(),
                  'CariSirketNo': credentials.SirketKodu.toString(),
                  'CoperSirketNo': credentials.CoperSirketNo.toString(),
                },
              }).then((response) => {
                // this.faturadialog = true


                this.sonucgeldi = true;

                document.getElementById("demo2").innerHTML = response.body;
                // document.getElementById('demo3').contentWindow.document.body.innerHTML = response.body;

                // this.file.push(response.body)

                var blob = new Blob([response.body], {
                  type: "text/html"
                });

                this.file = response.body

              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable-FaturaShow'
                  this.snackbar = true
                  this.sonucgeldi = true;
                } else {
                  this.text1 = 'Service Unavailable-FaturaShow'
                  this.snackbar = true
                  this.sonucgeldi = true;
                }
              })

            } else if (response.body.FaturaBilgi.EFaturaKayitli == '0') {


              this.mailtype = 'pdf'
              this.efaturali = false

              var prm1 = {
                id: this.faturaid,
                guid: this.FaturaInput.FaturaGuid
              };

              var prm = {
                SablonId: this.dizayn,
                PrintObjectName: null,
                IsTestData: false,
                Prm: prm1
              };

              this.$http.post(auth.API_URL + 'api/ReportBro/ReportBroPrintPdf2', prm, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader(),
                  'CariSirketNo': String(credentials.SirketKodu),
                  'CoperSirketNo': String(credentials.CoperSirketNo)
                },
                responseType: "application/json"
              }).then((response) => {

                if (response.body.Status == true) {

                  this.sonucgeldi = true;

                  var dosya = helpers.base64ToArrayBuffer(response.body.data);
                  var blob = new Blob([dosya], {
                    type: "application/pdf"
                  });
                    this.file = blob;

                  var file1 = window.URL.createObjectURL(blob);
                  document.getElementById("demo3").src = file1;
                } else {
                  this.text1 = response.body.ErrorList[0];
                  this.snackbar = true
                  this.sonucgeldi = true;

                }

              }, (response) => {

                this.text1 = response.body.ErrorList[0];
                this.snackbar = true
                this.sonucgeldi = true;


              })


            } else {
              this.text1 = this.$t('Your-invoice-could-not-be-brought')
              this.snackbar = true
              this.sonucgeldi = true;
            }
          } else {
            this.text1 = this.$t('Your-invoice-information-was-not-found')
            this.snackbar = true
            this.sonucgeldi = true;
          }



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-EInvoiceGet'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-EInvoiceGet'
            this.snackbar = true
          }
        })




      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    components: {
      'parainput': parainput,
      reportbrosablon,
      loadingcomp,
      yetkidialog,
      onaydialog,
      tarihcomp,
      EFaturaEkliDosya,
      TekrarGonderDosyaEkle,
      
    },
    watch: {},
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
       tekrarOnayaDosyaGonderSor() {
        this.$refs.onaydialog.open(
          this.$t('process-tries-sent-Invoice-Same-Invoice-Number-creates-new-number-you-really-wish-continue'),
          1).then(sonuc => {

          if (sonuc == true) {
            this.tekrarOnayaDosyaGonder();
          }

        });

      },
      tekrarOnayaGonderSor() {
        this.$refs.onaydialog.open(
          this.$t('process-tries-sent-Invoice-Same-Invoice-Number-creates-new-number-you-really-wish-continue'),
          1).then(sonuc => {

          if (sonuc == true) {
            this.tekrarOnayaGonder();
          }

        });

      },
      denemeyazdir(divName) {

        var mywindow = window.open('', 'PRINT', 'height=500,width=700');
        mywindow.document.write('</head>');
        mywindow.document.write('<style>');
        //yazdırılmayacak alanlar için css ekliyorum
        mywindow.document.write('@media print{.no-print {display:none !important;}}');
        mywindow.document.write('table{font-size:9px;border-collapse: collapse;}');
        mywindow.document.write('</style>');
        //   mywindow.document.write('<body >');
        mywindow.document.write(document.getElementById(divName).innerHTML);
        // mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

      },
     
      KesinBasariliIsaretle() {

        this.$refs.onaydialog.open(
          this.$t('process-will-mark-invoice-certain-success-you-really-wish-continue'),
          1).then(sonuc => {

          if (sonuc == true) {
            this.islemstatus = true
            var prm = {
              id: this.faturaid,
              guid: this.FaturaInput.FaturaGuid
            };

            tool.api_post(this, "EFatura/KesinBasariliIsaretle", prm).then(
              response => {

                this.text1 = response.body
                this.snackbar = true
                this.islemstatus = false



              },
              response => {
                this.islemstatus = false

                // this.status = tool.responseToStatus(response);
              }
            );
          }

        });
        //"Bu işlem Faturayı Kesin olarak başarılı oldu şeklinde işaretleyecek.\n Bu İşleme Gerçekten Devam Etmek istiyormusunuz?"


      },
      FaturaIptal() {

        this.$refs.onaydialog.open(
          this.$t('Do-you-wish-cancel-invoice'),
          1).then(sonuc => {

          if (sonuc == true) {
            this.islemstatus = true
            var prm = {
              id: this.faturaid,
              guid: this.FaturaInput.FaturaGuid
            };

            tool.api_post(this, "EFatura/FaturaIptal", prm).then(
              response => {

                this.text1 = response.body
                this.snackbar = true
                this.islemstatus = false



              },
              response => {
                this.islemstatus = false

                // this.status = tool.responseToStatus(response);
              }
            );
          }

        });
        //"Bu işlem Faturayı Kesin olarak başarılı oldu şeklinde işaretleyecek.\n Bu İşleme Gerçekten Devam Etmek istiyormusunuz?"


      },
      FaturaSil() {

        this.$refs.onaydialog.open(
          'Faturayı silmek istediğinize emin misiniz?',
          1).then(sonuc => {

          if (sonuc == true) {
            this.islemstatus = true
            var prm = {
              id: this.faturaid,
              guid: this.FaturaInput.FaturaGuid
            };

            tool.api_post(this, "EFatura/FaturaSil", prm).then(
              response => {

                this.text1 = response.body
                this.snackbar = true
                this.islemstatus = false



              },
              response => {
                this.islemstatus = false

                // this.status = tool.responseToStatus(response);
              }
            );
          }

        });
        //"Bu işlem Faturayı Kesin olarak başarılı oldu şeklinde işaretleyecek.\n Bu İşleme Gerçekten Devam Etmek istiyormusunuz?"


      },
      DialogShowManuelNoVer(v) {

        this.FaturaNoTip = v;

        var prm = {
          id: this.faturaid,
          guid: this.FaturaInput.FaturaGuid
        };

        tool.api_post(this, "EFatura/GetFaturaIcerik", prm).then(
          response => {


            this.FaturaIcerik = response.body;

            this.YeniFatura.tarih = this.FaturaIcerik.Fatura.tarih

            this.faturanodialog = true;

          },
          response => {}
        );
      },
      ManuelNoVer() {

        if (this.$refs.formfaturano.validate()) {

          this.islemstatus = true

          var prm = {


            FaturaId: {
              id: this.faturaid,
              guid: this.FaturaInput.FaturaGuid
            },
            YeniFatura: this.YeniFatura
          };

          tool.api_post(this, "EFatura/FaturaNoVer", prm).then(
            response => {
              this.islemstatus = false
              this.faturanodialog = false;
              this.text1 = response.body
              this.snackbar = true

            },
            response => {
              this.text1 = this.$t('Error-please-try-again')
              this.snackbar = true



            }
          );
        }
      },

      OnayFaturaNoVer() {
        if (this.$refs.formfaturano.validate()) {

          this.islemstatus = true

          var prm = {

            FaturaId: {
              id: this.faturaid,
              guid: this.FaturaInput.FaturaGuid
            },
            YeniFatura: this.YeniFatura
          };

          tool.api_post(this, "EFatura/OnayFaturaNoVer", prm).then(
            response => {
              this.islemstatus = false
              this.faturanodialog = false;
              this.text1 = response.body
              this.snackbar = true

            },
            response => {
              this.text1 = this.$t('Error-please-try-again')
              this.snackbar = true
            }
          );
        }
      },
      ekle() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          MusteriID: credentials.MusteriID,
          HareketTip: 'Fatura',
          HareketSayisi: 1
        }

        this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.UyelikStatus == true) {

            if (response.body.KontorStatus == true) {

              var url = '#/fatura/serbestfatura/id?islem=yeni'
              window.open(url, '_self')


            } else {
              this.text1 = this.$t('not-process-need-purchase-continue-process')
              this.snackbar = true
            }

          } else {
            this.text1 = this.$t('membership-expired-need-renew-membership-process')
            this.snackbar = true
          }


        }, (response) => {

          if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
            islemok = false
          } else {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
          }
        })

      },
      tekrarOnayaGonder() {
          this.islemstatus = true
        var prm = {
          id: this.faturaid,
          guid: this.FaturaInput.FaturaGuid
        }
       tool.api_post(this, "EFatura/TekrarGonder", prm).then(
          response => {
            if (response.body.OperationCompleted == true) {
              this.islemstatus = false
              this.text1 = 'Faturanız tekrar onaya gönderildi.' //response.body[0].message
              this.snackbar = true
              this.FaturaInput.FaturaGuid = response.body.guid
            } else {
              this.islemstatus = false
              this.text1 = response.body.error
              this.snackbar = true
            }
          },
          response => {
            this.text1 = response.body.ExceptionMessage
            this.snackbar = true
            this.islemstatus = false

            this.status = tool.responseToStatus(response);
          }
        );
      },
      tekrarOnayaDosyaGonder() {
      this.$refs.efatTekrarEkliDosya.open(this.faturatur, this.faturaid, this.FaturaInput.FaturaGuid).then((confirm) => {
        if (confirm !== "") {
        }
      });
      },
      EFaturaGonderDosyaEkle() {
      this.$refs.efaturaeklidosya.open(this.faturatur, this.faturaid, this.FaturaInput.FaturaGuid).then((confirm) => {
        if (confirm !== "") {
        }
      });
      },
      onayaGonder() {
        this.islemstatus = true
        var prm = {
          faturaTip: this.faturatur,
          faturaList: []
        };
        prm.faturaList.push({
          id: this.faturaid,
          guid: this.FaturaInput.FaturaGuid
        });

        tool.api_post(this, "EFatura/EfaturaGonder", prm).then(
          response => {
            if (response.body[0].OperationCompleted == true) {
              this.islemstatus = false
              this.text1 = this.$t('invoice-sent-approval')  //response.body[0].message
              this.snackbar = true

            } else {
              this.islemstatus = false
              this.text1 = 'Hata: ' + response.body[0].message
              this.snackbar = true
            }
          },
          response => {
            this.status = tool.responseToStatus(response);
            this.islemstatus = false

            this.text1 = response.body.InnerException.ExceptionMessage
            this.snackbar = true
          }
        );
      },
      addFiles() {
        this.$refs.file.click();
      },
      handleFileUpload() {
        this.file = []
        var uploadedFiles = this.$refs.file.files;

        if (uploadedFiles.length > 0) {

          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }

        } 
      },

      mailgonder() {
        var re =
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        var kont = re.test(this.email)
        if (kont == true) {
          this.epostagonder(this.email, this.mailtype)
        } else {
          this.text1 = "Hatalı Email.."
          this.snackbar = true;
        }

      },

      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      efaturagoster: efaturagoster,
      tarihkontrol: tarihkontrol,
      epostagonder: epostagonder,
      servishesapla: servishesapla,
      vergihesapla: vergihesapla,
      odemeseklikontrol: odemeseklikontrol
    },
  }

  function odemeseklikontrol(v) {

    if (v == "K") {
      return ("K-Kredili");
    } else if (v == "P") {
      return ("P-Peşin");
    } else if (v == "R") {
      return ("R-Kartlı");
    } else if (v == "C") {
      return ("C-Kartlı");
    } else if (v == "F") {
      return ("F-Kredi Kartlı");
    } else {
      return null;
    }
  }

  function epostagonder(kime, tip) {
    var cred = JSON.parse(window.localStorage.getItem('credentials'));
    let formData = new FormData();


    if (tip == 'pdf') {
      formData.append('file', new Blob([this.file], {
        type: 'application/pdf'
      }), this.sendFaturaNo + '-Fatura');
      formData.append('Tip', 'pdf')
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    }

    if (tip == 'htm') {
      formData.append('file', new Blob([this.file], {
        type: 'application/html'
      }), this.sendFaturaNo + '-Fatura');

      formData.append('Tip', 'htm')
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    }

    formData.append('CustomerCode', cred.AnaSirketKodu)
    formData.append('Konu', 'Arkman Fatura')
    formData.append('to', kime)
    formData.append('mailType', '0')
    formData.append('formattedMessage', 'ilgili faturanız ekte gönderilmiştir.')
    axios.defaults.baseURL = auth.API_URL;
    axios.responseType = 'arraybuffer';

    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {
            Authorization: `Bearer ${auth.getAuthHeader()}`
          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 = this.$t('Your-mail-has-been-sent')
          this.snackbar = true
        } else {
          this.text1 = this.$t('Your-mail-could-not-be-sent-please-try-again')
          this.snackbar = true
        }
      })
      .catch(function () {});
  }

  function efaturagoster() {

    var params = {
      id: this.faturaid,
      guid: this.FaturaInput.FaturaGuid,
      CreditNoteFilter:parseInt(this.creditnote)
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShowTest', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
      }
    }).then((response) => {

      document.getElementById("demo2XML").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }



  function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
      var parts = v.split("T");
      var parts1 = parts[0].split("-");
      return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
      return null;
    }
  }

  function beforeMount() {


  }

  function vergihesapla(tutarlar) {

    var gosterilecektutar = 0;

    gosterilecektutar = tutarlar.AlanVergiTutar.AlanVergiTutar + tutarlar.YFFTutar.YFFTutar + tutarlar.TaxTutar
      .TaxTutar +
      tutarlar.KaTutar.KaTutar;
    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100

    return (gosterilecektutar)
  }

  function servishesapla(tutarlar) {

    var gosterilecektutar = 0;
    gosterilecektutar = tutarlar.ServisTutar.ServisTutar + tutarlar.ReserveTutar.ReserveTutar + tutarlar
      .DigerServisTutar
      .DigerServisTutar - tutarlar.IskontoTutar.IskontoTutar;

    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
    return (gosterilecektutar)
  }

  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {

    this.tumsirketler = false
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>

<style>
  .ScrollStyle {
    max-height: 800px;
    max-width: 100%;
    overflow-x: scroll;
    overflow-y: scroll;
  }
</style>